'use client';
import { useCallback, useEffect, useRef } from 'react';

export const useIntersectionObserver = (callback, options = {}) => {
    const observerTarget = useRef(null);

    const observerCallback = useCallback(
        (entries) => {
            const [entry] = entries;
            if (entry?.isIntersecting) {
                callback(entries);
            }
        },
        [callback]
    );

    useEffect(() => {
        const target = observerTarget.current;
        const observer = new IntersectionObserver(observerCallback, {
            root: null,
            rootMargin: '100px',
            threshold: 0.25,
            ...options,
        });

        if (target) {
            observer.observe(target);
        }

        return () => {
            if (target) {
                observer.unobserve(target);
            }
        };
    }, [observerCallback, options]);

    return observerTarget;
};
